module.exports = __webpack_public_path__ + "static/media/cz.96423c19.svg";